export async function getLogoutUrl() {
  const mod = await import('./_ory.js');
  return mod.getLogoutUrl();
}
